import { z } from 'zod';
const filtersEntitySchema = z.object({
    eans: z.string().array().optional(),
    stores: z.string().array().optional(),
    activityTypes: z.union([z.string(), z.string().array()]).optional(),
    formats: z.string().array().optional(),
    products: z.string().array().optional(),
    brands: z.string().array().optional()
});
const comparisonFiltersEntitySchema = filtersEntitySchema.extend({
    startDate: z.coerce.date().optional(),
    endDate: z.coerce.date().optional()
});
const storePerimeterSchema = z.enum(['allStores', 'likeForLike']);
export { comparisonFiltersEntitySchema, filtersEntitySchema, storePerimeterSchema };
//# sourceMappingURL=projects.filters.model.js.map